export const MARKETING_SLICE_NAME = "marketing"
